import React, {Component} from 'react';
import styles from './DropdownTiny.module.css';
import Svg from "../Svg/Svg"

class DropdownTiny extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      label: props.label
    }

    this.onBodyClick = this.onBodyClick.bind(this)
    this.onCheckClick = this.onCheckClick.bind(this)
  }

  componentDidMount() {
    document.body.addEventListener('click', this.onBodyClick)
    document.body.addEventListener('touchstart', this.onBodyClick)
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClick)
    document.body.removeEventListener('touchstart', this.onBodyClick)
  }

  onBodyClick(event) {
    if(event.target !== this.checkbox) {
      setTimeout(() => {
        if(!this.checkbox) return

        this.setState({
          checked: false
        })
      }, 250)
    }
  }

  onCheckClick() {
    this.setState(prevState => ({
      checked: !prevState.checked
    }));
  }

  render() {
    const {
      checked,
      label
    } = this.state

    const {
      ariaLabel,
      children,
      altStyling
    } = this.props

    return (
      <div className={
        [
          styles.DropdownTiny,
          altStyling ? styles.DropdownTinyAlt : undefined,
          checked ? styles.DropdownTinyChecked : undefined
        ].filter(Boolean).join(' ')}>
        <input
          ref={node => this.checkbox = node}
          aria-label={ariaLabel}
          type="checkbox"
          id="lang-selector"
          onClick={this.onCheckClick}
          onChange={() => {}}
          className={styles.checkbox}
          checked={checked}
        />
        <label htmlFor="lang-selector" className={styles.label}>
          <span>{label}</span>
          <Svg id="dropdown-tiny" className={styles.icon}/>
          <Svg id="dropdown-tiny-arrow" className={styles.iconArrow}/>
        </label>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    );
  }
}

export default DropdownTiny;
